import React, { useEffect, useState } from "react";
import { Form, Button } from "semantic-ui-react";
import { Navigate, useNavigate } from "react-router-dom";
import "../css/Register.css";
import "../css/SelectRegister.css";

export default function SelectRegister() {
    let navigate = useNavigate();

    const redirectStudent = () => {
        navigate("/RegisterStudent");
    };

    const redirectSuper = () => {
        navigate("/RegisterSuperAdmin");
    };

    const redirectLogin = () => {
        navigate("/");
    };

    return (
        <div className="selectreg">
            <div className="ui center aligned padded grid register-box">
                <div className="row">
                    <div className="register-blue-sidebar column five wide">
                        <h2 className="register-app-title">Student Events</h2>
                    </div>
                    <div className="selectreg-box column eleven wide">
                        <div>
                            <h1 className="selectreg-header">WHO ARE YOU?</h1>
                            <Form>
                                <div className="selectreg-button">
                                    <Button className="selectreg-btn" onClick={redirectStudent}>
                                        I AM A STUDENT
                                    </Button>
                                </div>
                                <div className="selectreg-button">
                                    <Button className="selectreg-btn" onClick={redirectSuper}>
                                        I AM A UNIVERSITY ADMIN
                                    </Button>
                                </div>
                            </Form>
                            <a
                                className="selectreg-register-link"
                                onClick={redirectLogin}
                            >
                                Already have an account? Login
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
